module.exports = __webpack_public_path__ + "static/media/success.e9c21958.svg";